import { createEvent, restore } from "effector";
import { useStore } from "effector-react";
export var browserLanguageDetected = createEvent();
export var languageChanged = createEvent();
export var $language = restore(browserLanguageDetected, "ru");
browserLanguageDetected.watch(console.log);
export var useViewerLanguage = function () { return useStore($language); };
